<div id="login-widget">
    <router-outlet #o="outlet"></router-outlet>
</div> 